import { render, staticRenderFns } from "./ApplicantBlockBanner.vue?vue&type=template&id=b246d152&scoped=true"
import script from "./ApplicantBlockBanner.vue?vue&type=script&lang=js"
export * from "./ApplicantBlockBanner.vue?vue&type=script&lang=js"
import style0 from "./ApplicantBlockBanner.vue?vue&type=style&index=0&id=b246d152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b246d152",
  null
  
)

export default component.exports